import React, { useEffect, useState } from "react";
import { Button, Col, Input, Row, Table, Tooltip } from "antd";
import HeadingBack from "../component/HeadingBack";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import SvgIcon from "../const/SvgIcon";
import { allapiAction } from "../../Redux/common/action";
import { DownloadOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { Modal } from "antd";
import { URL } from "../../Redux/common/url";
import Api from "../../Redux/common/api";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";
import PdfGenerator from "./PdfGenerator";
import moment from "moment";
function Report() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pagev = searchParams.get("page");
  const searchData = searchParams.get("search");

  const { confirm } = Modal;

  const page = pagev == null ? 1 : pagev;
  const search = searchData == null ? "" : searchData;

  const get_product_list = useSelector((state) =>
    state?.allapi?.get_product_list ? state?.allapi?.get_product_list : {}
  );

  const [pages, setPage] = useState(1);

  const listdata = get_product_list?.docs ? get_product_list?.docs : [];
  const [startDate2vs, setStartDate2vs] = useState("");
  const [startDate2vse, setStartDate2vse] = useState("");
  const getPropertiesData = () => {
    const obj = { page: page };
    if (startDate2vs) {
      obj.startDate = startDate2vs;
    }
    if (startDate2vse) {
      obj.endDate = startDate2vse;
    }
    if (search) {
      obj.key = search;
    }
    dispatch(allapiAction.searchReposrt(obj));
    // if (search) {
    //   dispatch(allapiAction.searchReposrt({ page: page, key: search }));
    // } else {
    //   dispatch(allapiAction.getReportList(page));
    // }
  };
  useEffect(() => {
    getPropertiesData();

    return () => {};
  }, [location, startDate2vs, startDate2vse]);

  const showDeleteConfirm = (e) => {
    confirm({
      title: "Are you sure delete ?",
      icon: <ExclamationCircleFilled />,
      content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        hendleDelete(e);
        console.log("OK");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const hendleDelete = (e) => {
    console.log(e);
    // deleteProduct
    // setShowDelete(false);
    dispatch(allapiAction.deleteProduct({ productId: e, pageNo: page }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };
  const dataSource = [
    {
      key: "1",
      name: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      name: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addPropertyModal, setAddPropertyModal] = useState(false);
  const [loading, setloading] = useState(false);
  const [properties, setProperties] = useState([]);
  const [userId, setuserId] = useState("");

  console.log(properties);

  const uniqueObjects = properties.reduce((acc, current) => {
    const x = acc.find((item) => item.skimName === current.skimName);
    if (!x) {
      acc.push(current);
    }
    return acc;
  }, []);

  console.log(uniqueObjects);

  const [statusData, setstatusData] = useState({});
  const [userData, setuserData] = useState({});
  const [statusDataBox, setstatusDataBox] = useState(false);

  const hendleToViewM = (e) => {
    setstatusDataBox(true);
    setuserData(e);
  };

  const hendleTochangedata = (e) => {
    const { name, value } = e.target;

    setstatusData({ ...statusData, [name]: value });
  };

  const hendleToSubmetUpdate = () => {
    dispatch(
      allapiAction.addFoundByAdmin({
        id: userData?._id,
        amount: statusData?.amount,

        pageNumber: page,
      })
    );

    setstatusDataBox(false);
  };

  const showModal = (e) => {
    console.log(e);
    setuserId(e);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    dispatch(
      allapiAction.user_inactive({
        _id: userId,
        status: userId,
        // active: 0,
        pageNumber: page,
      })
    );
    setuserId("");
    setIsModalOpen(false);
    return () => {};
  };

  const hendleToChangeStatus = (id, status) => {
    dispatch(
      allapiAction.user_inactive({
        _id: id,
        status: status,
        // active: 0,
        pageNumber: page,
      })
    );
    // setuserId("");
    // setIsModalOpen(false);
    return () => {};
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const hendleToStatus = (id, e) => {
    // statusCategory

    dispatch(allapiAction.statusProduct({ productId: id, status: e }));
    // dispatch(adminAction.getRoleList('dhsg'))
    return () => {};
  };

  const columns = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno",
      className: "table_first_col",
      render: (value, item, index) => (page - 1) * 10 + index + 1,
    },
    // {
    //   title: "Image",
    //   dataIndex: "image",
    //   key: "image",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <div style={{ width: "100px" }}>
    //           <img
    //             style={{ width: "100%" }}
    //             src={URL?.API_BASE_URL + item?.featureImage}
    //             alt=""
    //           />
    //         </div>
    //       </>
    //     );
    //   },
    // },
    /* {
      title: "User Id",
      dataIndex: "referId",
      key: "referId",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            <span
              className="cursor-pointer coustomNevc"
              // onClick={() => navigate(`/user-details/${item?.referId}`)}
            >
              {item?.referId}
            </span>
          </>
        );
      },
    }, */

    // {
    //   title: "Name",
    //   dataIndex: "title",
    //   key: "title",
    // },

    {
      title: "Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Father/Husband",
      dataIndex: "fatharYaHusband",
      key: "fatharYaHusband",
    },
    {
      title: "Scheme",
      dataIndex: "skimName",
      key: "skimName",
    },
    {
      title: "transferred",
      dataIndex: "transferred",
      key: "transferred",
    },
    {
      title: "Recipt No",
      dataIndex: "rasidNo",
      key: "rasidNo",
    },
    {
      title: "number",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Schemedate",
      dataIndex: "Schemedate",
      key: "Schemedate",
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      className: "table_action_col",
      render: (value, item, index) => {
        return (
          <>
            {/* <Tooltip title="Edit">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showModal(item);
                }}
              >
                <SvgIcon.Edit className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                                hendleModalShow(item?.id)
                              }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
            <Tooltip title="View">
              <span
                className="cursor-pointer"
                onClick={() => {
                  navigate("/plots-details/" + item?._id);
                }}
              >
                <SvgIcon.Visibility className="scale-icon edit-icon" />
              </span>
            </Tooltip>
            {/* <Tooltip title="Delete">
              <span
                className="cursor-pointer"
                onClick={() => {
                  showDeleteConfirm(item?._id);
                }}
              >
                <SvgIcon.deletebtn className="scale-icon edit-icon" />
              </span>
            </Tooltip> */}
          </>
        );
      },
    },
    // {
    //   title: "Scheme",
    //   dataIndex: "categoryDetails",
    //   key: "categoryDetails",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <span className="cursor-pointer">{item?.categorymainId?.name}</span>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title={item?.status}>
    //           <button
    //             className={
    //               item?.status == "Active"
    //                 ? "success-button ml-3"
    //                 : "delete-button2 ml-3"
    //             }
    //             onClick={() =>
    //               hendleToStatus(
    //                 item?._id,
    //                 item?.status == "Active" ? "Inactive" : "Active"
    //               )
    //             }
    //           >
    //             {item?.status}
    //           </button>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
    // {
    //   title: "Actions",
    //   dataIndex: "action",
    //   key: "action",
    //   className: "table_action_col",
    //   render: (value, item, index) => {
    //     return (
    //       <>
    //         <Tooltip title="Edit">
    //           <span
    //             className="cursor-pointer"
    //             onClick={() => navigate(`/update-product/${item?.pro_slug}`)}
    //           >
    //             <SvgIcon.Pencil className="scale-icon edit-icon" />
    //           </span>
    //         </Tooltip>
    //         <Tooltip title="Delete">
    //           <span
    //             className="cursor-pointer"
    //             onClick={() => {
    //               showDeleteConfirm(item?._id);
    //             }}
    //           >
    //             <SvgIcon.deletebtn className="scale-icon edit-icon" />
    //           </span>
    //         </Tooltip>
    //       </>
    //     );
    //   },
    // },
  ];

  const [searchs, setsearch] = useState("");
  const handleChange = (e) => {
    setsearch(e);
    setPage(1);
    navigate("/report?page=" + 1 + "&search=" + e);
  };

  const hendlePahegi = (e) => {
    setPage(e);
    console.log(location);
    navigate("/report?page=" + e + "&&search=" + search);
  };

  const handleToAddProperty = async () => {
    const token = localStorage.getItem("admin_token");
    setloading(true);

    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    try {
      if (!loading) {
        try {
          const chunkSize = 500;
          const chunks = Array.from(
            { length: Math.ceil(properties.length / chunkSize) },
            (v, k) => properties.slice(k * chunkSize, (k + 1) * chunkSize)
          );
          for (const chunk of chunks) {
            await Api.post(
              `${URL.createPropertiesByExcel}`,
              { properties: chunk },
              config
            );
          }
        } catch (error) {
          console.error("Error uploading chunks:", error);
        }
        // if (response.status === 200) {
        //   toast.success("Properties added successfully!!");
        // }
        // setAddPropertyModal(false);
        // getPropertiesData();
        // setloading(false);
        // navigate(0);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Some error occured!!");
      setloading(false);
    }
  };
  const handleFileUpload = (event) => {
    const propertyExcel = event.target.files[0];
    const reader = new FileReader();
    const convertExcelDate = (serialNumber) => {
      const baseDate = new Date(1899, 11, 30); // 1899-12-30
      const convertedDate = new Date(
        baseDate.getTime() + serialNumber * 86400000
      );
      return convertedDate.toISOString().split("T")[0]; // YYYY-MM-DD format
    };
    reader.onload = async (e) => {
      const binaryStr = new Uint8Array(e.target.result);
      const workbook = XLSX.read(binaryStr, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const propertyData = XLSX.utils.sheet_to_json(worksheet);

      const finalData = propertyData.map((item, i) => {
        console.log(i);
        console.log(item);

        item.fullName = item?.Name;
        item.fatharYaHusband = item["Father's/Husband's Name"];
        item.area = item["Area Sq. Gaj"];
        item.Schemedate = item?.date;
        item.number = item["Plot No."];
        item.lengthWidth = item["L X W Feet"];
        item.rasidNo = item?.Receipt;
        item.skimName = item["scheme Name"];
        // item.RegDate = convertExcelDate(item?.RegDate);
        // item.name = item?.skimName;
        // item.label = item?.skimName;
        // item.transferred = item?.transferred ? item?.transferred : "";
        item.type = item?.Land;
        // item.fullName = item?.fullName;
        // item.fatharYaHusband = item?.fatharYaHusband;
        // item.area = item?.area;
        // item.Schemedate = item?.date;
        // item.number = item?.number;
        // item.rasidNo = item?.rasidNo;
        // item.skimName = item?.skimName;
        // item.RegDate = convertExcelDate(item?.RegDate);
        // // item.name = item?.skimName;
        // item.label = item?.skimName;
        // item.transferred = item?.transferred ? item?.transferred : "";
        // item.type = item?.type == "दकान" ? "shop" : "plot";
        // item.sr = item?.sr;
        return item;
      });
      setProperties(finalData);
    };

    reader.readAsArrayBuffer(propertyExcel);
  };

  const downloadExampleExcel = () => {
    const link = document.createElement("a");
    link.href = "../media/property/example.xlsx";
    link.download = "example.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const downloadSchemes = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const response = await Api.get(`${URL.getcateAllList}`, config);
    const data = response.data?.data;

    if (data.length === 0) {
      toast.error("No Schemes found");
    } else {
      let schemes = data.map((item) => {
        return {
          ["Scheme Name"]: item?.name,
          ["Loaction"]: item?.loaction,
          ["Registered Date"]: item?.RegDate,
          ["Area Bigha"]: item?.areaBigha,
          id: item?._id,
        };
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(schemes);
      
      const colWidths = Object.keys(schemes[0]).map((key) => {
        const maxContentLength = Math.max(
          key.length,
          ...schemes.map((scheme) => (scheme[key] ? scheme[key].toString().length : 0))
        );
        return { width: maxContentLength + 2 }; // Adding 2 for padding
      });
  
      worksheet["!cols"] = colWidths;

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "schemes.xlsx");
    }
  };
  const downloadProPerty = async () => {
    const token = localStorage.getItem("admin_token");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    const formData = {};
    const response = await Api.post(
      `${URL.getcateAllProperty}`,
      formData,
      config
    );
    const data = response.data?.data;

    if (data.length === 0) {
      // toast.error("No Schemes found");
    } else {
      let schemes = data.map((item, i) => {
        return {
          ["Sr. No. "]: i + 1,
          ["Onwer Name"]: item?.fullName,
          ["Father's/Husband's Name"]: item?.fatharYaHusband,
          ["Scheme Name"]: item?.skimName,
          ["Address"]: item?.Address,
          ["Area"]: item?.area,
          ["Plot/Shop No."]: item?.number,
          ["Type"]: item?.type,
          ["Sold"]: item?.sold,
          ["Recept No."]: item?.rasidNo,

          ["Sale Date"]: item?.sellinDate
            ? moment(item?.sellinDate).format(" DD/MM/YYYY ")
            : "",
          ["Transafard"]: item?.transferred,
        };
      });
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(schemes);
      const colWidths = Object.keys(schemes[0]).map((key) => {
        const maxContentLength = Math.max(
          key.length,
          ...schemes.map((scheme) => (scheme[key] ? scheme[key].toString().length : 0))
        );
        return { width: maxContentLength + 2 }; // Adding 2 for padding
      });
  
      worksheet["!cols"] = colWidths;
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(blob, "property.xlsx");
    }
  };
  return (
    <div>
      <Modal
        title="delete User"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>Are you sure delete</p>
      </Modal>

      <Modal
        title="Add Amount"
        centered
        open={statusDataBox}
        onOk={() => hendleToSubmetUpdate(false)}
        onCancel={() => setstatusDataBox(false)}
        width={500}
      >
        <div>
          <Row>
            <Col span={24}>Amount</Col>
            <Col span={24}>
              <Input
                name="amount"
                placeholder="enter amount"
                value={statusData?.amount}
                onChange={(e) => {
                  hendleTochangedata(e);
                }}
              />
            </Col>
          </Row>
        </div>
      </Modal>

      <Modal
        title="Add Property"
        centered
        open={addPropertyModal}
        onOk={handleToAddProperty}
        onCancel={() => setAddPropertyModal(false)}
        width={500}
        okText={loading ? "Loading..." : "Submit"}
      >
        <div>
          <Row>
            <Col span={24}>
              <input
                type="file"
                accept=".xlsx, .xls"
                onChange={handleFileUpload}
              />
            </Col>
          </Row>
        </div>
      </Modal>
      <div className="flex">
        <div>
          <HeadingBack
            title={"Reports"}
            subHeading={`Total ${get_product_list?.totalDocs || 0} Reports`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <label>Search</label>
          <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          />
        </Col>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <label>From Date</label>
          <div className="input-field">
            <i className="fas fa-calendar-check-o"></i>
            <input
              type="date"
              required=""
              name="dob"
              placeholder="Enter dob"
              onChange={(e) => {
                setStartDate2vs(e?.target?.value);
              }}
            />
          </div>
        </Col>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          <label>To Date</label>
          <div className="input-field">
            <i className="fas fa-calendar-check-o"></i>
            <input
              type="date"
              required=""
              name="dob"
              placeholder="Enter dob"
              onChange={(e) => {
                setStartDate2vse(e?.target?.value);
              }}
            />
          </div>

          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        {/* <div className="flex1 flex justify-content-end align-items-center">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => navigate("/add-product")}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div> */}
        <div className="flex1 flex justify-content-end align-items-center">
          <div style={{ marginLeft: 50, whiteSpace: "nowrap" }}>
            {/* <Tooltip title="Download" placement="topRight">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={downloadExampleExcel}
              >
                Example Excel
              </Button>
            </Tooltip> */}
            {/* <Tooltip title="Download" placement="topLeft">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={downloadSchemes}
              >
                Download Schemes
              </Button>
            </Tooltip> */}
            <PdfGenerator />
            <Tooltip title="Download" placement="topLeft">
              <Button
                type="primary"
                icon={<DownloadOutlined />}
                onClick={downloadProPerty}
              >
                Download Property
              </Button>
            </Tooltip>
            {/* <Tooltip title="Add">
              <Button
                type="primary"
                className="jop_btn"
                onClick={() => setAddPropertyModal(true)}
              >
                Add Property
              </Button>
            </Tooltip> */}
          </div>
        </div>
      </div>

      <div className="tableResponsive mt-10">
        <Table
          className={"table antd_table"}
          dataSource={listdata}
          columns={columns}
          pagination={{
            current: parseInt(page),
            pageSize: 10,
            onChange(current, pageSize) {
              hendlePahegi(current);
            },
            hideOnSinglePage: true,
            total: get_product_list?.totalDocs
              ? get_product_list?.totalDocs
              : 0,
          }}
        />
      </div>
    </div>
  );
}

export default Report;
